window.miniCartCheckbox = {
    buttonCheckbox: null,
    inputCheck: null,

    init: function() {
        this.buttonCheckbox = document.querySelector('.cart__checkout-button');
        this.inputCheck = document.querySelector('.cart-drawer__footer input#check-policy');

        if (!this.buttonCheckbox || !this.inputCheck) return;

        const savedState = localStorage.getItem("check-policy");
        if (savedState === "true") {
            this.inputCheck.checked = true;
        }
        this.checkBox();
        this.inputCheck.addEventListener('change', () => this.checkBox());
    },

    checkBox: function() {
        const isChecked = this.inputCheck.checked;
        
        if (isChecked) {
            this.buttonCheckbox.removeAttribute('disabled');
            localStorage.setItem("check-policy", "true");
        } else {
            this.buttonCheckbox.setAttribute('disabled', '');
            localStorage.setItem("check-policy", "false");
        }
    }
};

document.addEventListener('DOMContentLoaded', () => {
    window.miniCartCheckbox.init();
});